"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CatalogLoading_module_scss_1 = __importDefault(require("./CatalogLoading.module.scss"));
function CatalogLoading() {
    return (react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.skeleton },
        react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.line }),
        react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.line }),
        react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.group }, [...Array(6)].map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("div", { key: index },
            react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.img }),
            react_1.default.createElement("div", { className: CatalogLoading_module_scss_1.default.label })))))));
}
exports.default = CatalogLoading;
